import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/terms/page.tsx")